export default "__VITE_ASSET__Dd4Yn87I__"